import { render } from "./result.vue?vue&type=template&id=1da5a883&scoped=true"
import script from "./result.vue?vue&type=script&lang=js"
export * from "./result.vue?vue&type=script&lang=js"

import "./result.vue?vue&type=style&index=0&id=1da5a883&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da5a883"]])

export default __exports__